<template>
  <span :class="type" class="logo">
    <img :src="logo" alt="logo" />
    {{ type !== "only" ? name : "" }}
  </span>
</template>

<style scoped lang="scss">
@import "./logo-style.scss";
</style>

<script>
import logo from "~/static/images/logo.svg";

export default {
  data() {
    return {
      logo: logo,
    };
  },
  props: {
    type: {
      type: String,
      default: "only",
    },
    name: {
      type: String,
      default: "Motanamy",
    },
  },
};
</script>
